import {useEffect, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {MODELS} from '../../../../../Apis/Models';
import {TABLES} from '../../../../../Apis/Tables';
import {handleSelfieImage} from '../../../../../reduxToolkit/CompanyEmployees/CompanyEmployeesSlice';
import {clearSearchFilters} from '../../../../../reduxToolkit/Search/SearchSlice';
import {DeleteItemsApi} from '../../../../../reduxToolkit/Commons/CommonsApi';
import {VIEW_TYPE} from '../../../../../enums/ViewType';
import routes from '../../../../../Routes/routes';
import {errorMsg} from '../../../../../Apis/functions';
import {CommonDocumentationApp} from "../../../Contractors/CompanyDocumentation/Functionality/CommonDocumentationApp";
import {GetUserRestriction} from "../../../../../reduxToolkit/restrictions/RestrictionApi";

const AllEmployeeApp = () => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { getUserFullInformation } = useSelector((state) => state.CommonsSlice);
    const { getUserRestriction } = useSelector((state) => state?.RestrictionSlice);
    const contractorId = sessionStorage.getItem('contractorId');
    const supplierId = sessionStorage.getItem('providerId');
    const [view, setView] = useState(VIEW_TYPE.LIST.name);
    const [creationErrorsShow, setCreationErrorsShow] = useState(false);
    const [spreadsheetData, setSpreadsheetData] = useState(null);
    const [importFileShow, setImportFileShow] = useState(false);
    const [criteria, setCriteria] = useState();
    const [search, setSearch] = useState(false);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [searchElement, setSearchElement] = useState('');
    const [bodyForExport, setBodyForExport] = useState();
    const [selectForDelete, setSelectForDelete] = useState([]);
    const [deleteEmployeeShow, setDeleteEmployeeShow] = useState(false);
    const [finalArray, setFinalArray] = useState([]);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [expandImage, setExpandImage] = useState('');
    const [modified, setModified] = useState(false);
    const [filterDialogShow, setFilterDialogShow] = useState(false);
    let moduleId;
    let option;

    if (contractorId !== null) {
        moduleId = `${MODELS.ContractorEmployee}`;
        option = `${TABLES.CONTRACTOR_EMPLOYEE}`;
    } else if (supplierId !== null) {
        moduleId = `${MODELS.SupplierEmployee}`;
        option = `${TABLES.SUPPLIER_EMPLOYEE}`;
    } else {
        // Props to the filter window
        moduleId = `${MODELS.Employee}`;
        option = `${TABLES.EMPLOYEES}`;
    }
    const [showActionsContractorSupplier, setShowActionsContractorSupplier] = useState(false);
    const { isActiveContractorSupplier } = CommonDocumentationApp();

    useEffect(() => {
        if(getUserFullInformation?.statusId){
            setShowActionsContractorSupplier(isActiveContractorSupplier(getUserFullInformation?.statusId));
        }
    }, [getUserFullInformation]);

    /**
     * reset image
     */
    useEffect(() => {
        dispatch(handleSelfieImage(null));
    }, []);

    useEffect(() => {
        sessionStorage.removeItem('contractId');
        sessionStorage.removeItem('supplier_order_id');
        if(!getUserRestriction?.id) dispatch(GetUserRestriction());

        return () => {
            dispatch(clearSearchFilters());
        };
    }, []);

    const handleView = (view) => {
        setSearchElement('');
        setIsAllChecked(false);
        setBodyForExport(null);
        setCriteria(null);
        setView(view);
    }

    const goCreate = () => {
        if (contractorId !== null) {
            return navigate(routes.contractor.createEmployee);
        }
        if (supplierId !== null) {
            return navigate(routes.suppliers.createEmployee);
        }
        navigate(routes.employee.create);
    };

    const deleteSelectedEmployees = (deleteItem) => {
        const tableName = contractorId !== null ? TABLES.CONTRACTOR_EMPLOYEE : supplierId !== null ? TABLES.SUPPLIER_EMPLOYEE : TABLES.EMPLOYEES;
        const body = deleteItem;
        if (body.length > 0) {
            dispatch(DeleteItemsApi({ tableName, body })).then(({payload: {data: { success, code }}}) => {
                    if (success === true) {
                        setModified(true);
                        setSelectForDelete([]);
                        setIsAllChecked(false);
                    }else errorMsg(code);
                },
            );
        }
    };

    return {
        t,
        permission,
        DEV,
        moduleId,
        option,
        getUserRestriction,
        contractorId, supplierId,
        view, setView,
        creationErrorsShow, setCreationErrorsShow,
        spreadsheetData, setSpreadsheetData,
        importFileShow, setImportFileShow,
        criteria, setCriteria,
        search, setSearch,
        simpleSearch, setSimpleSearch,
        searchElement, setSearchElement,
        bodyForExport, setBodyForExport,
        selectForDelete, setSelectForDelete,
        deleteEmployeeShow, setDeleteEmployeeShow,
        finalArray, setFinalArray,
        isAllChecked, setIsAllChecked,
        expandImage, setExpandImage,
        modified, setModified,
        filterDialogShow, setFilterDialogShow,
        goCreate,
        deleteSelectedEmployees,
        handleView,
        showActionsContractorSupplier
    };
};

export default AllEmployeeApp;
